interface DropdownContentProps {
    el: HTMLDivElement;
}

const DropdownContent = ({ el }: DropdownContentProps): void => {
    const contentItems = el.querySelectorAll('.dropdown-content-item');
    const buttons = el.querySelectorAll('.dropdown-buttons-container > [data-target-content]');

    buttons.forEach(btn => {
        const targetId = (btn as HTMLElement).dataset.targetContent;
        btn.addEventListener('click', () => {
            buttons.forEach(deselectButton => {
                deselectButton.classList.remove('active');
            });
            btn.classList.add('active');
            contentItems.forEach(elItem => {
                elItem.classList.remove('is-active');
                if (elItem.id === targetId) {
                    elItem.classList.add('is-active');
                }
            });
        });
    });
};

export default DropdownContent;
